import { render, staticRenderFns } from "./itso.vue?vue&type=template&id=947ff424&scoped=true&"
import script from "./itso.vue?vue&type=script&lang=js&"
export * from "./itso.vue?vue&type=script&lang=js&"
import style0 from "./itso.vue?vue&type=style&index=0&id=947ff424&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "947ff424",
  null
  
)

export default component.exports